/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { ContentJson } from '@/types/domain/privateBlog/entities/contentEntity';
import type { CategoryItemsType, PrivateBlogStateType } from '@/types/domain/privateBlog/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

const initialState: PrivateBlogStateType = {
  categoryItems: undefined,
  content: undefined,
};

/**
 * Slice
 */
export const privateBlogSlice = createSlice({
  name: 'privateBlog',
  initialState,
  reducers: {
    /** カテゴリアイテムをセット */
    setCategoryItems: (state, action: PayloadAction<CategoryItemsType | undefined
    >) => {
      state.categoryItems = action.payload;
    },
    /** コンテンツをセット */
    setPrivateBlogContent: (state, action: PayloadAction<{ item: ContentJson } | undefined>) => {
      state.content = action.payload;
    },
  },
});
